import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddRewardItemModal from "./AddRewardItemModal";
import { sendVerificationCodeThunk, verifyCodeThunk, getAllRewardsThunk } from "../store/rewards";
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import { Context } from "../context/AppContext";

export function RewardModal({ isOpen, onClose, points, phone, handlePhoneChange }) {
  const dispatch = useDispatch();
  const rewards = useSelector((state) => state.rewards.rewards);
  const { restaurantId, changedCart } = useContext(Context);
  const [selectedItem, setSelectedItem] = useState(null);
  const [addFreeItemModal, setAddFreeItemModal] = useState(false);
  const [currentRewardItem, setCurrentRewardItem] = useState(null);
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [verificationStep, setVerificationStep] = useState(1); // 1: Send Code, 2: Verify Code
  const [verificationMessage, setVerificationMessage] = useState('');
  const [choosedReward, setChoosedReward] = useState(null);

  useEffect(() => {
    setCurrentRewardItem(JSON.parse(localStorage.getItem('rewardItem')) || false);
  }, [changedCart]);

  useEffect(() => {
    dispatch(getAllRewardsThunk(restaurantId));
  }, [dispatch, restaurantId]);

  const handleRedeem = async (reward) => {
    const verifiedPhone = JSON.parse(localStorage.getItem('verifiedPhone')) || false;

    if (!verifiedPhone) {
      setShowVerifyModal(true); // Show verification modal
      setChoosedReward(reward);
    } else {
      setSelectedItem(reward.Item);
      setAddFreeItemModal(true);
    }
  };

  const handleSendCode = async () => {
    const sendResult = await sendVerificationCodeThunk(phone)(dispatch);
    if (sendResult && sendResult.message === 'success') {
      setVerificationStep(2); // Move to code verification step
      setVerificationMessage('Verification code sent to your phone.');
    } else {
      setVerificationMessage('Failed to send verification code. Please try again.');
    }
  };

  const handleVerifyCode = async (userCode) => {
    const verifyResult = await verifyCodeThunk(phone, userCode)(dispatch);
    if (verifyResult && verifyResult.message === 'success') {
      localStorage.setItem('verifiedPhone', JSON.stringify(true));
      setVerificationMessage('Phone verified successfully!');
      setTimeout(() => {
        setShowVerifyModal(false); // Hide verification modal
        setSelectedItem(choosedReward.Item);
        setAddFreeItemModal(true);

      }, 1000);
    } else {
      setVerificationMessage('Verification failed. Please try again.');
    }
  };

  if (!isOpen) return null;
  const formatPhoneNumber = (phone) => {
    if (phone.length > 6) {
      return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
    } else if (phone.length > 3) {
      return `(${phone.slice(0, 3)}) ${phone.slice(3)}`;
    } else if (phone.length > 0) {
      return `(${phone}`;
    }
    return '';
  };

  return (
    <>
      <Modal show={!showVerifyModal} onHide={onClose} centered size="lg">
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="w-100 text-center fw-bold" style={{ fontSize: '1.5rem' }}>
            🎁 Redeem a Reward
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="text-center mb-4">
            <h6 className="fw-semibold mb-2" style={{ fontSize: '1.1rem' }}>
              Your Points:
              <span className="ms-2 px-3 py-1 rounded-pill bg-success text-white">
                {points}
              </span>
            </h6>

            <div className="col-md-6 mx-auto my-3">
              <input
                type="tel"
                className="form-control text-center shadow-sm"
                id="phone"
                value={formatPhoneNumber(phone)}
                onChange={handlePhoneChange}
                placeholder="(123) 456-7890"
                required
                maxLength={14}
                style={{ fontSize: '1rem' }}
              />
            </div>

            <p className="text-danger small mb-0">
              * Only one reward item can be redeemed per order.
            </p>
          </div>
{rewards?.length === 0 && (
  <p className="text-center text-muted my-4">
    Currently there are no rewards. Please wait for the restaurant to add rewards.
  </p>
)
}
          <div className="custom-scrollbar" style={{ maxHeight: '500px', overflowY: 'auto' }}>
            <div className="row g-4 px-2">
              {rewards?.map((reward) => {
                const isSelected = currentRewardItem?.Item?.id === reward.Item.id;
                const isDisabled = points < reward.need_amount || isSelected;

                return (
                  <div key={reward.id} className="col-md-4 col-sm-6">
                    <div
                      className="card h-100 border-0 shadow-sm text-center"
                      style={{ transition: 'transform 0.2s', borderRadius: '10px' }}
                    >
                      <img
                        src={
                          reward.Item.image_url ||
                          'https://theme-assets.getbento.com/sensei/a342b2d.sensei/assets/images/catering-item-placeholder-704x520.png'
                        }
                        alt={reward.Item.name}
                        className="card-img-top rounded-top"
                        style={{ height: '150px', objectFit: 'cover' }}
                      />
                      <div className="card-body d-flex flex-column justify-content-between px-3 pb-3">
                        <h5 className="card-title fw-semibold" style={{ fontSize: '1.05rem' }}>
                          {reward.Item.name}
                        </h5>
                        {/* <p className="text-muted small mb-2" style={{ minHeight: '40px' }}>
                          {reward.Item.description !== 'null'
                            ? reward.Item.description
                            : 'No description available.'}
                        </p> */}
                        <p className="fw-semibold small mb-2">
                          Points Needed: {reward.need_amount}
                          <br />
                          <span className={`fw-bold ${points >= reward.need_amount ? 'text-success' : 'text-danger'}`}>
                            You have: {points}
                          </span>
                        </p>

                        <button
                          className={`btn btn-sm fw-semibold px-3 py-2 ${isSelected ? 'btn-outline-secondary' : 'btn-primary'
                            }`}
                          style={{ borderRadius: '6px', fontSize: '0.9rem' }}
                          disabled={isDisabled}
                          onClick={() => handleRedeem(reward)}
                        >
                          {isSelected ? 'Selected Reward' : 'Redeem'}
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-between align-items-center w-100 px-3">
          <div className="fw-semibold small text-muted">
            {currentRewardItem ? (
              <>Current Reward: <strong>{currentRewardItem.Item.name}</strong></>
            ) : (
              <>No reward selected</>
            )}
          </div>
          <button
            type="button"
            className="btn btn-outline-dark fw-semibold px-4 py-2"
            style={{ borderRadius: '6px' }}
            onClick={onClose}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showVerifyModal} onHide={() => setShowVerifyModal(false)} centered>
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="w-100 text-center fw-bold">📱 Phone Verification</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {verificationStep === 1 && (
            <div className="text-center">
              <p className="mb-3">We need to verify your phone number to redeem points.</p>
              <button className="btn btn-primary" onClick={handleSendCode}>
                Send Verification Code
              </button>
            </div>
          )}

          {verificationStep === 2 && (
            <div className="text-center">
              <p className="mb-3">Enter the code sent to your phone:</p>
              <input
                type="tel"
                className="form-control text-center mx-auto"
                style={{ width: '150px' }}
                placeholder="Enter code"
                maxLength={6}
                onChange={(e) => {
                  const code = e.target.value;
                  if (code.length === 6) {
                    handleVerifyCode(code);
                  }
                }}
              />
            </div>
          )}

          {verificationMessage && (
            <p className="mt-3 text-success text-center">{verificationMessage}</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShowVerifyModal(false)}>
            Close
          </button>
        </Modal.Footer>
      </Modal>


      <AddRewardItemModal item={selectedItem} modal={addFreeItemModal} setModal={setAddFreeItemModal} />
    </>
  );
}
